/**
 * PLACEHOLDER: returns the reporting number for a residue in one of an antibody's domains.
 *
 * Antibody numbering (e.g. EU or Kabat) is not available yet, so this reports the residue's 1-based position
 * within its domain. The real implementation will read the domain's numbering, shaped like
 * `AntibodyNumberingInfo` in benchling/benchling_domain_graph/sdl/schemas/molbio/aa_sequences.graphql, where a
 * residue may be unnumbered.
 *
 * TODO(BNCH-171153 follow-up): replace with antibody numbering once the numbering module exists.
 */
export function numberAntibodyResidue(_domainLabel: string, residueIndex: number): string {
  return String(residueIndex + 1);
}
